import React, { useContext, useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import axios from 'axios';
import { ConfigurationContext } from '../context/ConfigurationContext';
import REACT_APP_API_BASE_URL from '../index.js';

const LoadingView = () => {
  const { configurations, setConfigurations } = useContext(ConfigurationContext);
  const [state, setState] = useState({ loading: true, error: false, redirect: false });

  useEffect(()=>{
    axios
      .get( REACT_APP_API_BASE_URL + '/configuration' )
      .then(response => {
        setConfigurations({ ...configurations, items: response.data });
        setState({ ...state, loading: false, redirect: true });
      })
      .catch( err => {
        setState({ ...state, loading: false, error: true });
      });
  }, []);

  if (state.redirect) {
    return <Redirect to='/start'/>;
  }

  return (
    <div>
      {state.loading ? <h4>Laddar...</h4>
        : state.error ? <h4>Fel uppstod!</h4>
        : null}
    </div>
  );
};

export default LoadingView;
